import { ReviewRun } from "../../types/reviewTypes";
import { ReviewActionTypes } from "../actions/review";

interface ReviewState {
  loading: boolean;
  runs: ReviewRun[];
}
const initialState: ReviewState = {
  runs: [],
  loading: false,
};

export default function review(
  state = initialState,
  action: ReviewActionTypes
): ReviewState {
  switch (action.type) {
    case "SET_REVIEW_HISTORY":
      return {
        ...state,
        runs: action.payload.history,
      };
    case "SET_REVIEW_RUN":
      return {
        ...state,
        runs:
          action.payload.action === "CREATE"
            ? [...state.runs, action.payload.run]
            : state.runs.filter(
                (run) => run.runId !== action.payload.run.runId
              ),
      };
    case "SET_REVIEW_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
}
